import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useSidebar } from '../../contexts/SidebarContext';
import { cn } from '../../utils/cn';

const SidebarCollapseButton = () => {
  const { isCollapsed, toggleSidebar } = useSidebar();

  return (
    <button
      onClick={toggleSidebar}
      className={cn(
        "absolute -right-3 top-1/2 -translate-y-1/2",
        "w-6 h-12 flex items-center justify-center",
        "bg-gradient-to-r from-slate-900 to-slate-800",
        "rounded-r-lg border-r border-y border-slate-700/50",
        "text-slate-400 hover:text-white",
        "transition-all duration-200",
        "focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
        "group"
      )}
      aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
    >
      {isCollapsed ? (
        <ChevronRight className="w-4 h-4 group-hover:scale-110 transition-transform" />
      ) : (
        <ChevronLeft className="w-4 h-4 group-hover:scale-110 transition-transform" />
      )}
    </button>
  );
};

export default SidebarCollapseButton;